// Custom gift wrap cart update
// @see https://support.maestrooo.com/article/304-technical-javascript-events-exposed-by-the-theme
// % prettier assets/agmes-gift-wrap.js --write --single-quote

// Line item property label
// Should match the value entered in the "Label" field for
// the "Line item property" block on the product page template
const agmesLineItemPropertyLabel = 'Add gift wrapping';

document.addEventListener('cart:change', function (event) {
  let cart = event.detail.cart;
  let baseEvent = event.detail.baseEvent;

  //console.log('cart:change', event, baseEvent);
  if (baseEvent == 'variant:add' || baseEvent == 'line-item:change') {
    agmesGiftWrap(cart.items, 'drawer');
  }
});

document.addEventListener('DOMContentLoaded', function () {
  if (document.querySelector('.cart-page')) {
    const cartRequest = fetch(window.Shopify.routes.root + 'cart.js', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        // Needed for Shopify to check inventory
      },
    });

    cartRequest
      .then(function (response) {
        response.json().then(function (cart) {
          agmesGiftWrap(cart.items, 'page');
        });
      })
      .catch(function (error) {
        //console.log(error);
      });
  }
});

// Check cart items for gift wrap attributes
function agmesGiftWrap(items, element) {
  let giftWrapItem = false;
  let giftWrapItemQuantity = 0;
  let itemsWithGiftWrap = 0;

  items.forEach((item) => {
    let itemPropertiesKeys = Object.keys(item.properties);
    //console.log(item.title, itemPropertiesKeys);

    // Check for items with gift wrapping property
    if (itemPropertiesKeys.find((key) => key.includes(agmesLineItemPropertyLabel))) {
      //console.log('Item has gift wrap property', itemPropertiesKeys.find((key) => key.includes(agmesLineItemPropertyLabel)));
      itemsWithGiftWrap += Number(item.quantity);
    }

    // Check for gift wrap item
    if (item.id == agmesGiftWrapId) {
      giftWrapItem = true;
      giftWrapItemQuantity = item.quantity;
    }
  });

  if (items.length > 0) {
    //console.log('Gift wrap item quantity', giftWrapItemQuantity);
    //console.log('Items with gift wrap', itemsWithGiftWrap);

    // Cart contains items with gift wrap property and gift wrap item quantity doesn't match
    if (itemsWithGiftWrap > 0 && itemsWithGiftWrap != giftWrapItemQuantity) {
      agmesGiftWrapUpdate(itemsWithGiftWrap);
    }

    // Cart contains gift wrap item and no other items with gift wrap property
    if (giftWrapItem && itemsWithGiftWrap == 0) {
      agmesGiftWrapUpdate(itemsWithGiftWrap);
    }
  }
}

// Update gift wrap cart item quantity
function agmesGiftWrapUpdate(quantity, refresh) {
  //console.log('Updating gift wrap quantity', quantity, 'Refresh', refresh);

  if (typeof agmesGiftWrapId !== 'number') {
    //console.log('Could not find gift wrap product id');
    return false;
  }

  // Update gift wrap cart item quanity
  const cartRequest = fetch(window.Shopify.routes.root + 'cart/update.js', {
    body: JSON.stringify({
      updates: {[agmesGiftWrapId]: quantity},
    }),
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
      // Needed for Shopify to check inventory
    },
  });

  cartRequest
    .then(function (response) {
      response.json().then(function (cart) {
        //console.log('Updated cart', cart.items);
      });
    })
    .catch(function (error) {
      console.log(error);
    })
    .finally(function () {
      //console.log('Refreshing cart');

      if (document.querySelector('.cart-page')) {
        window.location.reload();
      }

      // Fire theme event to refresh cart
      document.documentElement.dispatchEvent(
        new CustomEvent('cart:refresh', {
          bubbles: true,
        }),
      );
    });
}
